import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Toaster } from "../components/ui/sonner";
import { ArrowLeft, ShieldCheck } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Signed in");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white grid md:grid-cols-2">
      <div className="hidden md:block relative h-screen sticky top-0 overflow-hidden border-r border-slate-200">
        <img
          src="https://images.pexels.com/photos/6985136/pexels-photo-6985136.jpeg"
          alt="abstract"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-slate-900/70" />
        <div className="relative h-full p-12 flex flex-col text-white">
          <Link to="/" data-testid="login-back" className="inline-flex items-center gap-2 font-mono-sms text-xs uppercase tracking-[0.2em] opacity-80 hover:opacity-100">
            <ArrowLeft size={14} weight="bold" /> Back home
          </Link>
          <div className="mt-auto">
            <div className="font-mono-sms text-xs uppercase tracking-[0.3em] mb-4 opacity-80">
              Registrar Console
            </div>
            <h1 className="font-display text-5xl font-black tracking-tighter leading-[0.95]">
              The control room
              <br />
              for admissions.
            </h1>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-12">
        <form onSubmit={submit} className="w-full max-w-md">
          <ShieldCheck size={32} weight="duotone" className="text-[var(--sms-primary)] mb-4" />
          <h2 className="font-display text-4xl font-black tracking-tighter mb-2">
            Sign in.
          </h2>
          <p className="text-slate-500 text-sm mb-10">Admin credentials only.</p>

          <div className="space-y-5">
            <div>
              <div className="font-mono-sms text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-2">Email</div>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="sms-input"
                data-testid="login-email"
              />
            </div>
            <div>
              <div className="font-mono-sms text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-2">Password</div>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="sms-input"
                data-testid="login-password"
              />
            </div>
            <button
              type="submit"
              disabled={submitting}
              data-testid="login-submit"
              className="sms-btn-primary w-full"
            >
              {submitting ? "Signing in…" : "Sign in →"}
            </button>
          </div>

        </form>
      </div>
      <Toaster position="top-right" richColors />
    </div>
  );
}
